import React, { useState } from "react";
import "./App.css";

function App() {
  const [value, setValue] = useState("");

  return (
    <div className="container">
      <h1 className="calculator-name">Awesome Calculator</h1>

      <div className="calculator">
        <form action="">
          <div className="display">
            <input
              type="text"
              value={value}
              onClick={(e) => setValue(value + e.target.value)}
            />
          </div>
          <div>
            <input type="button" value="AC" onClick={(e) => setValue("")} />
            <input
              type="button"
              value="DE"
              onClick={(e) => setValue(value.slice(0, -1))}
            />
            <input
              type="button"
              value="."
              onClick={(e) => setValue(value + e.target.value)}
            />
            <input
              type="button"
              value="/"
              onClick={(e) => setValue(value + e.target.value)}
            />
          </div>
          <div>
            <input
              type="button"
              value="7"
              onClick={(e) => setValue(value + e.target.value)}
            />
            <input
              type="button"
              value="8"
              onClick={(e) => setValue(value + e.target.value)}
            />
            <input
              type="button"
              value="9"
              onClick={(e) => setValue(value + e.target.value)}
            />
            <input
              type="button"
              value="*"
              onClick={(e) => setValue(value + e.target.value)}
            />
          </div>
          <div>
            <input
              type="button"
              value="4"
              onClick={(e) => setValue(value + e.target.value)}
            />
            <input
              type="button"
              value="5"
              onClick={(e) => setValue(value + e.target.value)}
            />
            <input
              type="button"
              value="6"
              onClick={(e) => setValue(value + e.target.value)}
            />
            <input
              type="button"
              value="+"
              onClick={(e) => setValue(value + e.target.value)}
            />
          </div>
          <div>
            <input
              type="button"
              value="1"
              onClick={(e) => setValue(value + e.target.value)}
            />
            <input
              type="button"
              value="2"
              onClick={(e) => setValue(value + e.target.value)}
            />
            <input
              type="button"
              value="3"
              onClick={(e) => setValue(value + e.target.value)}
            />
            <input
              type="button"
              value="-"
              onClick={(e) => setValue(value + e.target.value)}
            />
          </div>
          <div>
            <input
              type="button"
              value="00"
              onClick={(e) => setValue(value + e.target.value)}
            />
            <input
              type="button"
              value="0"
              onClick={(e) => setValue(value + e.target.value)}
            />
            <input
              type="button"
              value="="
              className="equal"
              onClick={(e) => setValue(eval(value))}
            />
          </div>
        </form>
      </div>
      <footer className="footer">
        <p>
          © 2023 Awesome Calculator. All rights reserved -{" "}
          <a
            href="https://www.softaxy.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Softaxy
          </a>{" "}
          |{" "}
          <span>
            Designed by{" "}
            <a
              href="https://github.com/Victor-Adeleye"
              target="_blank"
              rel="noopener noreferrer"
            >
              Victor Adeleye
            </a>
          </span>
        </p>
      </footer>
    </div>
  );
}

export default App;
